import PropTypes from 'prop-types';
import React from 'react';
import EmptyState from '../../../member-pages-common/components/empty-state';
import withTranslate from '../../../app/hoc/with-translate';

const NoPosts = ({ t, isAllowedToCreatePost, ...props }) => (
  <EmptyState
    title={t(isAllowedToCreatePost ? 'no-posts.title' : 'no-posts-allowed.title')}
    content={t(isAllowedToCreatePost ? 'no-posts.content' : 'no-posts-allowed.content')}
    {...props}
  />
);

NoPosts.propTypes = {
  t: PropTypes.func,
  isAllowedToCreatePost: PropTypes.bool,
};

export default withTranslate(NoPosts);
